export const setNotificationsReadAll = (payload: {activeItem: number}) => ({
  type: "@saga/SET_NOTIFICATIONS_READ_ALL",
  payload
});
